export const HERO_VIDEO_OUTRO_RAMP_SECONDS = 3;

const INTRO_RAMP_SECONDS = 2.2;
const MIN_PLAYBACK_RATE = 0.5;
const RATE_STEP = 0.1;
const MIN_RATE_CHANGE_INTERVAL_MS = 250;

export function getHeroVideoPlaybackMode({ userAgent = '', platform = '', maxTouchPoints = 0 } = {}) {
    // iPadOS can identify itself as macOS. iOS browsers share the WebKit media stack.
    const isAppleMobile = /iPhone|iPad|iPod/.test(userAgent)
        || (platform === 'MacIntel' && maxTouchPoints > 1);
    // WebKit web views need not include a Safari token. Blink browsers also
    // advertise AppleWebKit, so exclude their identifying browser tokens.
    const isWebKit = /AppleWebKit\//.test(userAgent)
        && !/Chrome\/|Chromium\/|CriOS\/|Edg\/|EdgiOS\/|OPR\/|FxiOS\//.test(userAgent);

    return isAppleMobile || isWebKit ? 'fixed' : 'bounded';
}

function getRampRate(video) {
    if (video.currentTime < INTRO_RAMP_SECONDS) {
        return MIN_PLAYBACK_RATE + (1 - MIN_PLAYBACK_RATE) * video.currentTime / INTRO_RAMP_SECONDS;
    }

    const remainingTime = video.duration - video.currentTime;
    if (remainingTime < HERO_VIDEO_OUTRO_RAMP_SECONDS) {
        return MIN_PLAYBACK_RATE
            + (1 - MIN_PLAYBACK_RATE) * Math.max(0, remainingTime / HERO_VIDEO_OUTRO_RAMP_SECONDS);
    }

    return 1;
}

export function createHeroVideoPlaybackController({ mode = 'bounded', now = () => performance.now() } = {}) {
    let lastRateChangeAt = -Infinity;

    return {
        reset() {
            lastRateChangeAt = -Infinity;
        },
        sync(video) {
            if (video.paused || video.ended || !Number.isFinite(video.duration) || video.duration <= 0) return;

            const rampRate = mode === 'fixed' ? 1 : getRampRate(video);
            const targetRate = mode === 'bounded'
                ? Math.round(rampRate / RATE_STEP) * RATE_STEP
                : rampRate;
            if (Math.abs(video.playbackRate - targetRate) <= 0.001) return;

            const timestamp = now();
            // Both timeupdate and the progress animation use this same limiter.
            if (mode === 'bounded' && timestamp - lastRateChangeAt < MIN_RATE_CHANGE_INTERVAL_MS) return;

            video.playbackRate = targetRate;
            lastRateChangeAt = timestamp;
        },
    };
}
